import { Script, ScriptStatus } from "@ea/shared_types/types";

export const formatScriptName = (script: Script) => script.name;

export const isScriptReadonly = (script: Script) =>
  [ScriptStatus.PUBLISHED, ScriptStatus.CLOSED].includes(script.status);
